export const TITLE = 'Prazo de Expiração';
export const READ_TITLE = 'Faixa(s) de Prazo de Expiração';
export const EDIT_TITLE = 'Adicionar Faixa de Prazo de Expiração';
export const TOOL_TIP = 'Adicionar Faixa';
export const TOOLTIP_TRASH = 'Excluir Faixa';
export const PRAZO = 'Prazo';
export const FIELD_INITIAL = 'De';
export const FIELD_FINAL = 'Até';
